import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendResponse } from '@schenck/rotec-components';

export interface Routes {
  statistics: boolean;
  production: boolean;
  quality: boolean;
  operators: boolean;
  notifications: boolean;
  condition: boolean;
  [key: string]: boolean;
}

export interface ManagedObject {
  id: string;
  name: string;
  type: 'csd_mc_routingConfig';
  creationTime: string;
  csd_mc_routingConfig?: Routes;
}

export const STANDARD_ROUTING_CONFIG: Routes = {
  statistics: true,
  production: true,
  quality: true,
  operators: false,
  notifications: false,
  condition: false,
};

@Injectable()
export class RoutingApi {
  protected http = inject(HttpClient);


  /**
   * Get routing configuration from backend
   */
  getRoutingConfig$(): Observable<BackendResponse.Response<{ managedObjects: ManagedObject[] }>> {
    const url = '/inventory/managedObjects?pageSize=1000&type=csd_mc_routingConfig';
    return this.http
      .get<{ managedObjects: ManagedObject[] }>(url)
      .pipe(BackendResponse.mapToResponse());
  }
}
